module.exports = __webpack_public_path__ + "media/venue/workshops@1x-b950569e.png";